var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"common"},[_c('h1',[_vm._v("common Component")])])
}]

export { render, staticRenderFns }